import { render, staticRenderFns } from "./TradingVolumeChart.vue?vue&type=template&id=f701f16e&scoped=true&"
import script from "./TradingVolumeChart.vue?vue&type=script&lang=js&"
export * from "./TradingVolumeChart.vue?vue&type=script&lang=js&"
import style0 from "./TradingVolumeChart.vue?vue&type=style&index=0&id=f701f16e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f701f16e",
  null
  
)

export default component.exports